import { useNavigate } from "react-router-dom";

import { CreateForm } from "@/tasks/components";
import { useCreateTodo } from "@/tasks/hooks";

import type { CreateTaskFormData } from "@/tasks/form/schema";

const Create = () => {
  const navigate = useNavigate();
  const { mutateAsync: createTodoMutation, isPending: isLoading } =
    useCreateTodo();

  const handleSubmit = async (data: CreateTaskFormData) => {
    try {
      await createTodoMutation({
        userId: 1,
        title: data.title,
        completed: false,
      });

      navigate("/");
    } catch (error) {
      console.error("Erro ao criar tarefa:", error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-2xl mx-auto">
          <div className="mb-8">
            <button
              onClick={() => navigate("/tasks")}
              className="flex items-center text-blue-600 hover:text-blue-700 mb-4 transition-colors"
            >
              <svg
                className="w-5 h-5 mr-2"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                  clipRule="evenodd"
                />
              </svg>
              Voltar para a lista
            </button>

            <h1 className="text-4xl font-bold text-gray-900 mb-2">
              Criar Nova Tarefa
            </h1>
            <p className="text-gray-600 text-lg">
              Preencha os campos abaixo para criar uma nova tarefa
            </p>
          </div>

          <div className="bg-white/80 backdrop-blur-sm rounded-2xl border border-white/20 shadow-sm p-8">
            <CreateForm onSubmit={handleSubmit} isLoading={isLoading} />
          </div>
        </div>
      </div>
    </div>
  );
};

export { Create };
